import { useState, useReducer, useEffect } from 'react';
import Nav from './Nav';

const dataReducer = (state, action) => {
    switch(action.type) {
        case 'value':
            return {
                ...state,
                [action.key]: action.value
            }

        case 'code':
            return {
                ...state,
                commands: {
                    ...state.commands,
                    [action.code]: {
                        ...state.commands[action.code],
                        [action.key]: action.value
                    }
                }
            }

        case 'command':
            return {
                ...state,
                commands: {
                    ...state.commands,
                    [action.code]: {
                        ...state.commands[action.code],
                        [action.command]: {
                            ...state.commands[action.code][action.command],
                            [action.key]: action.value
                        }
                    }
                }
            }

        case 'newCode':
            return {
                ...state,
                commands: {
                    ...state.commands,
                    [action.value]: {}
                }
            }

        case 'newCommand':
            return {
                ...state,
                commands: {
                    ...state.commands,
                    [action.key]: {
                        ...state.commands[action.key],
                        [action.value]: {}
                    }
                }
            }
        
        default:
            return state;
    }
}

const sublevelsReducer = (state, action) => {
    switch(action.type) {
        case 'initial':
            return action.value;

        case 'create':
            return [...state, {
                key: '',
                value: ''
            }];
    

        case 'update':
            return state.map((item, key) => {
                if (key === parseInt(action.key)) {
                    item[action.levelKey] = action.levelValue;
                }
                return item;
              });

        case 'delete':
            return state.filter((_, index) => index !== parseInt(action.key));

        default:
            return state;
    }
}

const Form = ({commands, finish}) => {
    const [data, setData] = useReducer(dataReducer, commands);
    const [activeCode, setActiveCode] = useState(null);
    const [activeCommand, setActiveCommand] = useState(null);
    const [sublevels, setSublevels] = useReducer(sublevelsReducer, []);

    const setGeneralItem = (key, value) => {
        setData({
            type: 'value',
            key,
            value
        })
    }

    const setMoveCommands = (key, value) => {
        let mCommands = data.moveCommands;
        mCommands[key] = value;

        setData({
            type: 'value',
            key: 'moveCommands',
            value: mCommands
        });
    }

    const deleteMoveCommand = (key) => {
        let mCommands = data.moveCommands;
        mCommands.splice(key, 1);

        setData({
            type: 'value',
            key: 'moveCommands',
            value: mCommands
        });
    }

    const newMoveCommand = () => {
        let mCommands = data.moveCommands;
        mCommands.push('');

        setData({
            type: 'value',
            key: 'moveCommands',
            value: mCommands
        });
    }

    const updateCode = (code, key, value) => {
        setData({
            type: 'code',
            code, 
            key,
            value,
        });
    }

    const updateCommand = (code, command, key, value) => {
        setData({
            type: 'command',
            code, 
            command,
            key,
            value,
        });
    }

    const setCommand = (commandKey) => {
        setActiveCommand(commandKey);
        let sl = [];
        if (data.commands[activeCode][commandKey]?.sublevels) {
            Object.keys(data.commands[activeCode][commandKey].sublevels).forEach((key) => {
                sl.push({
                    key,
                    value: data.commands[activeCode][commandKey].sublevels[key]
                });
            })
        }
        setSublevels({
            type: 'initial',
            value: sl
        });
    }

    const saveSublevels = () => {
        let sl = {};
        sublevels.forEach(item => {
            if (item.key && item.value)
                sl[item.key] = item.value
        })
        updateCommand(activeCode, activeCommand, 'sublevels', sl);
        setSublevels({
            type: 'initial',
            value: sublevels.filter(item => item.key && item.value)
        });
    }

    const download = () => {
        const jsonString = JSON.stringify(data, null, 2); 
        const blob = new Blob([jsonString], { type: 'application/json' });
        const url = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = (data.manufacturer + '_' + data.model + '_' + data.controller + '_' + data['years-made']).toLocaleLowerCase() + '.json';
        a.click();

        URL.revokeObjectURL(url); 
    }

    useEffect(() => {
        const intervalId = setInterval(() => {
            localStorage.setItem('commands', JSON.stringify(data));
        }, 30000);

        return () => clearInterval(intervalId);
    }, [data]);

    return (
        <>
            <div className="download">
                <button type="button" onClick={finish}>Finish editing</button>
                <button type="button" onClick={download}>Download JSON</button>
            </div>
            <form className="json-form">
                <Nav data={data} setData={setData} 
                    activeCode={activeCode} activeCommand={activeCommand} 
                    setActiveCode={setActiveCode} setActiveCommand={setActiveCommand}
                    setCommand={setCommand} />
                <section>
                    {!activeCode && !activeCommand ? <>
                        <h2>General Info</h2>
                        <div className="form-control">
                            <label>Author</label>
                            <input type="text" name="author" value={data.author} onChange={(event) => setGeneralItem(event.target.name, event.target.value)} />
                        </div>
                        <div className="form-control">
                            <label>Version</label>
                            <input type="text" name="version" value={data.version} onChange={(event) => setGeneralItem(event.target.name, event.target.value)} />
                        </div>
                        <div className="form-control">
                            <label>Type</label>
                            <input type="text" name="type" value={data.type} onChange={(event) => setGeneralItem(event.target.name, event.target.value)} />
                        </div>
                        <div className="form-control">
                            <label>Manufacturer</label>
                            <input type="text" name="manufacturer" value={data.manufacturer} onChange={(event) => setGeneralItem(event.target.name, event.target.value)} />
                        </div>
                        <div className="form-control">
                            <label>Model</label>
                            <input type="text" name="model" value={data.model} onChange={(event) => setGeneralItem(event.target.name, event.target.value)} />
                        </div>
                        <div className="form-control">
                            <label>Controller</label>
                            <input type="text" name="controller" value={data.controller} onChange={(event) => setGeneralItem(event.target.name, event.target.value)} />
                        </div>
                        <div className="form-control">
                            <label>Years</label>
                            <input type="text" name="years-made" value={data['years-made']} onChange={(event) => setGeneralItem(event.target.name, event.target.value)} />
                        </div>
                        <div className="form-control">
                            <label>Move commands</label>
                            <div className="move-commands">
                                {data.moveCommands && 
                                    <>{data.moveCommands.map((item, key) => (
                                        <div key={key}>
                                            <input type="text" name="moveCommand" maxLength={1} value={item} onChange={(event) => setMoveCommands(key, event.target.value)} />
                                            <span onClick={() => deleteMoveCommand(key)}>&#x2715;</span>
                                        </div>
                                    ))}</>
                                }
                                <div className="flex-right">
                                    <button type="button" onClick={newMoveCommand}>Add move command</button>
                                </div>
                            </div>
                        </div>
                    </> : ''}
                    {activeCode && !activeCommand ? <>
                        <h2>Code {activeCode}</h2>
                        <div className="form-control">
                            <div className="checkbox">
                                <input type="checkbox" name="main" id={`main_${activeCode}`} checked={parseInt(data.commands[activeCode].main || 0) === 1} onChange={(event) => updateCode(activeCode, event.target.name, parseInt(data.commands[activeCode].main || 0) ? 0 : 1)} />
                                <label htmlFor={`main_${activeCode}`}>Main command</label>
                            </div>
                        </div>
                    </> : ''}
                    {activeCode && activeCommand ? <>
                        <h2>Command {activeCode}{!isNaN(activeCommand) ? '': ' '}{activeCommand}</h2>
                        <div className="form-control">
                            <label>Value</label>
                            <input type="text" name="value" value={data.commands[activeCode][activeCommand].value || ''} onChange={(event) => updateCommand(activeCode, activeCommand, event.target.name, event.target.value)} />
                        </div>
                        <div className="form-control">
                            <label>Subcommand</label>
                            <div className="checkbox">
                                <input type="checkbox" name="exclude" id={`exclude_${activeCode}_${activeCommand}`} checked={parseInt(data.commands[activeCode][activeCommand].exclude || 0) === 1} onChange={(event) => updateCommand(activeCode, activeCommand, event.target.name, parseInt(data.commands[activeCode][activeCommand].exclude || 0) ? 0 : 1)} />
                                <label htmlFor={`exclude_${activeCode}_${activeCommand}`}>{parseInt(data.commands[activeCode][activeCommand].exclude || 0) === 1 ? 'On' : 'Off'}</label>
                            </div>
                        </div>
                        <div className="form-control">
                            <label>Subcommands</label>
                            {sublevels ? 
                                <div className="subcommands">
                                    {Object.keys(sublevels).map((key) => (
                                        <div key={key}>
                                            <input type="text" name="key" maxLength={1} value={sublevels[key].key} onChange={(event) => setSublevels({type: 'update', key, levelKey: event.target.name, levelValue: event.target.value.toLocaleUpperCase()})} />
                                            <input type="text" name="value" value={sublevels[key].value} onChange={(event) => setSublevels({type: 'update', key, levelKey: event.target.name, levelValue: event.target.value})} />
                                            <span onClick={() => setSublevels({type: 'delete', key})}>&#x2715;</span>
                                        </div>
                                    ))}
                                    <div className="flex-right">
                                        <button type="button" onClick={() => setSublevels({type: 'create'})}>Add subcommand</button>
                                        <button type="button" onClick={saveSublevels}>Save subcommands</button>
                                    </div>
                                </div>
                                : ''
                            }
                        </div>
                    </> : ''}
                </section>
            </form>
        </>
    );
};

export default Form;